module.exports = __webpack_public_path__ + "static/media/pl.3fe3bd51.svg";